import { Button } from "@kirvanobr/button";
import { Dropdown, DropdownItem, DropdownMenu, DropdownTrigger } from "@kirvanobr/dropdown";
import { AlignLeft, Brush01, ChevronDown, File04 } from "@untitled-ui/icons-react";
import { CertificateEditorHeaderProps } from "./CertificateEditor.types";

import { useCertificateStore } from "@/stores";
import { styles as s } from "./CertificateEditor.styles";
import { useCertificateEditor } from "./hooks/useCertificateEditor";

export const CertificateEditorHeader = ({
  otherOptions,
  formattingOptions,
  headingsOptions,
  textAlignOptions,
  fontFamilyOptions,
  colorEditor,
  onChangeColorEditor,
  handleChangeOrientation,
}: CertificateEditorHeaderProps) => {
  const { handleEnableEditing, handleRestore } = useCertificateEditor();
  const { orientation } = useCertificateStore();

  return (
    <div className={s().editorHeader()}>
      <div className="flex items-center">
        <div className="flex items-center">
          {otherOptions.map(({ id, icon, onClick }) => (
            <Button color="tertiary" variant="link" size="sm" key={id} onClick={onClick} className={s().menuItem()}>
              {icon}
            </Button>
          ))}
        </div>
        {/* <div className="flex px-2">
          <Dropdown>
            <DropdownTrigger>
              <Button endContent={<ChevronDown />} variant="link">
                {headingsOptions?.find(item => item.active)?.name ?? ""}
              </Button>
            </DropdownTrigger>
            <DropdownMenu>
              {headingsOptions.map(({ id, name, onClick }) => (
                <DropdownItem key={id} onClick={onClick}>
                  {name}
                </DropdownItem>
              ))}
            </DropdownMenu>
          </Dropdown>
        </div> */}
        <div className="flex px-2">
          <Dropdown>
            <DropdownTrigger>
              <Button color="tertiary" endContent={<ChevronDown className="w-4" />} variant="link" size="sm">
                {fontFamilyOptions?.find(item => item.active)?.name ?? "Fonte Padrão"}
              </Button>
            </DropdownTrigger>
            <DropdownMenu>
              {fontFamilyOptions.map(({ id, name, onClick }) => (
                <DropdownItem key={id} onClick={onClick}>
                  {name}
                </DropdownItem>
              ))}
            </DropdownMenu>
          </Dropdown>
        </div>
        <div className="flex items-center px-2">
          <Dropdown>
            <DropdownTrigger>
              <Button color="tertiary" isIconOnly endContent={<ChevronDown className="w-4" />} variant="link">
                <AlignLeft className="h-5 w-5" />
              </Button>
            </DropdownTrigger>
            <DropdownMenu>
              {textAlignOptions.map(({ id, icon, name, onClick }) => (
                <DropdownItem key={id} onClick={onClick}>
                  <div>
                    <div className="flex items-center">
                      <span className="mr-1">{icon}</span> <span>{name}</span>
                    </div>
                  </div>
                </DropdownItem>
              ))}
            </DropdownMenu>
          </Dropdown>
        </div>
        <div className="flex items-center px-2">
          <label
            className="h-[20px] w-[20px] rounded  shadow-sm block cursor-pointer"
            htmlFor="head"
            style={{
              backgroundColor: colorEditor ? colorEditor : "#000",
            }}
          >
            <input
              className="opacity-0 h-full w-full rounded-full overflow-hidden invisible"
              id="head"
              type="color"
              value={colorEditor ? colorEditor : "#000"}
              onInput={onChangeColorEditor}
            />
          </label>
        </div>
        <div className="flex items-center gap-3">
          {formattingOptions.map(({ id, icon, onClick }) => (
            <Button color="tertiary" variant="link" size="sm" key={id} onClick={onClick} className={s().menuItem()}>
              {icon}
            </Button>
          ))}
        </div>
      </div>

      <div className="flex gap-4">
        <div className="flex gap-2">
          <Button
            color="tertiary"
            isIconOnly
            size="sm"
            className={s().btnOrientationActive({ selectedOrientation: orientation == "Landscape" })}
            variant="outlined"
            onClick={() => handleChangeOrientation("Landscape")}
          >
            <File04 className="-rotate-90" />
          </Button>
          <Button
            color="tertiary"
            isIconOnly
            size="sm"
            className={s().btnOrientationActive({ selectedOrientation: orientation == "Portrait" })}
            variant="outlined"
            onClick={() => handleChangeOrientation("Portrait")}
          >
            <File04 />
          </Button>
        </div>
        <div className="flex gap-2">
          <Button
            variant="auxiliary"
            size="sm"
            startContent={<Brush01 className="h-5 w-5" />}
            onClick={handleEnableEditing}
          >
            Personalizar
          </Button>
          <Button color="tertiary" size="sm" onClick={handleRestore}>
            Restaurar padrão
          </Button>
        </div>
      </div>
    </div>
  );
};
